"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAssociatedTokenAccount = exports.findAssociatedTokenAddress = void 0;
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const SYSTEM_PROGRAM = new web3_js_1.PublicKey('11111111111111111111111111111111');
function findAssociatedTokenAddress(walletAddress, tokenMintAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield web3_js_1.PublicKey.findProgramAddress([
            walletAddress.toBuffer(),
            constants_1.TOKEN_PROGRAM_PUBLIC_KEY.toBuffer(),
            tokenMintAddress.toBuffer(),
        ], constants_1.ASSOCIATED_TOKEN_PROGRAM_PUBLIC_KEY))[0];
    });
}
exports.findAssociatedTokenAddress = findAssociatedTokenAddress;
function createAssociatedTokenAccountIx(fundingAddress, walletAddress, splTokenMintAddress) {
    return __awaiter(this, void 0, void 0, function* () {
        const associatedTokenAddress = yield findAssociatedTokenAddress(walletAddress, splTokenMintAddress);
        const keys = [
            {
                pubkey: fundingAddress,
                isSigner: true,
                isWritable: true,
            },
            {
                pubkey: associatedTokenAddress,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: walletAddress,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: splTokenMintAddress,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: SYSTEM_PROGRAM,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: constants_1.TOKEN_PROGRAM_PUBLIC_KEY,
                isSigner: false,
                isWritable: false,
            },
            {
                pubkey: web3_js_1.SYSVAR_RENT_PUBKEY,
                isSigner: false,
                isWritable: false,
            },
        ];
        const ix = new web3_js_1.TransactionInstruction({
            keys,
            programId: constants_1.ASSOCIATED_TOKEN_PROGRAM_PUBLIC_KEY,
            data: Buffer.from([]),
        });
        return {
            ix,
            associatedTokenAddress
        };
    });
}
function createAssociatedTokenAccount({ funder, owner, mint, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { ix, associatedTokenAddress } = yield createAssociatedTokenAccountIx(funder, owner, mint);
        return {
            ix,
            associatedTokenAddress
        };
    });
}
exports.createAssociatedTokenAccount = createAssociatedTokenAccount;
